var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linfocitos-barras-apiladas",attrs:{"id":_vm.barras_apiladas_id}},[_c('h3',{staticClass:"m-0"},[_vm._v("Distribución del conteo de linfocitos T CD4+")]),_c('svg',{staticClass:"svg-barras-apiladas"},[_c('defs'),_c('g',{staticClass:"grupo-contenedor-de-barras"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }